import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppShell } from '@flexibilitypay/ui';
import { useAuthStore, useSettingsStore } from '@flexibilitypay/shared';

import { NAV_SECTIONS } from './nav-items';
import { VersionFooter } from '../shared/components/version-footer';

function pageTitleFor(pathname: string): string {
  const match = NAV_SECTIONS.flatMap((s) => s.items).find((i) =>
    i.to === '/' ? pathname === '/' : pathname.startsWith(i.to),
  );
  return match?.label ?? 'Flexibilitypay';
}

export function DashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const collapsed = useSettingsStore((s) => s.sidebarCollapsed);
  const toggleSidebar = useSettingsStore((s) => s.toggleSidebar);
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  return (
    <AppShell
      appName="Flexibilitypay"
      appSubtitle="Backoffice PSP"
      navSections={NAV_SECTIONS}
      currentPath={location.pathname}
      collapsed={collapsed}
      onToggleCollapsed={toggleSidebar}
      onNavigate={(to) => navigate(to)}
      userEmail={user?.email}
      onLogout={logout}
      pageTitle={pageTitleFor(location.pathname)}
    >
      <Outlet />
      <VersionFooter />
    </AppShell>
  );
}
